/**
 * Utils - Funciones utilitarias del proyecto
 *
 * Funciones puras y reutilizables que no dependen del estado de React.
 * Cada función debe ser simple, hacer una sola cosa y ser fácil de testear.
 */

/**
 * Combina clases CSS condicionalmente
 * Alternativa ligera a clsx/classnames
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}

/**
 * Scroll suave a un elemento por su ID
 */
export function scrollToElement(elementId: string): void {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

/**
 * Debounce para optimizar eventos frecuentes
 */
export function debounce<T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), wait);
  };
}

/**
 * Formatea una fecha para mostrar
 */
export function formatDate(date: Date, locale = 'es-ES'): string {
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
